module.exports = __webpack_public_path__ + "img/checklist.20e50d68.svg";